import * as THREE from "three";

interface Props {
  color: string;
  bgColor: string;
}
const SingleBox = (props: Props) => {
  const horLine = new THREE.Shape()
    .moveTo(0, 0) //top left corner
    .lineTo(0, 4 / 12)
    .lineTo(48 / 12, 4 / 12)
    .lineTo(48 / 12, 0)
    .lineTo(0, 0);

  const vertLine = new THREE.Shape()
    .moveTo(0, 0)
    .lineTo(4 / 12, 0)
    .lineTo(4 / 12, 72 / 12)
    .lineTo(0, 72 / 12)
    .lineTo(0, 0);

  return (
    <group>
      {/* Top */}
      <mesh position={[0, -4 / 12, 0]} rotation={[0, 0, 0]}>
        <shapeGeometry args={[horLine]} />
        <meshBasicMaterial color={props.color} />
      </mesh>
      {/* Bottom */}
      <mesh position={[0, -72 / 12, 0]} rotation={[0, 0, 0]}>
        <shapeGeometry args={[horLine]} />
        <meshBasicMaterial color={props.color} />
      </mesh>
      {/* left */}
      <mesh position={[0, -72 / 12, 0]} rotation={[0, 0, 0]}>
        <shapeGeometry args={[vertLine]} />
        <meshBasicMaterial color={props.color} />
      </mesh>
      {/* right */}
      <mesh position={[(48 - 4) / 12, -72 / 12, 0]} rotation={[0, 0, 0]}>
        <shapeGeometry args={[vertLine]} />
        <meshBasicMaterial color={props.color} />
      </mesh>
    </group>
  );
};

const BattersBox = (props: Props) => {
  return (
    <>
      {/* Right BB */}
      <group position={[(8.5 + 6) / 12, (8.5 + 36) / 12, 0]}>
        <SingleBox color={props.color} bgColor={props.color} />
      </group>
      {/* Left BB */}
      <group position={[(-8.5 - 6 - 48) / 12, (8.5 + 36) / 12, 0]}>
        <SingleBox color={props.color} bgColor={props.color} />
      </group>
    </>
  );
};

export default BattersBox;
